import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import store from "@/store";
import { getGroups } from '@/composables/groupService';
export default function classroomsListQuery() {
    const toast = useToast()
    const refClassroomListTable = ref(null)
    const perPage = ref(10)
    const totalClassrooms = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const groupOptions = ref([])
    const groupFilter = ref(null)
    
    const tableColumns = ref([
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: 'group', label: i18n.t('Groups'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') }
    ])

    const dataMeta = computed(() => {
        const localItemsCount = refClassroomListTable.value ? refClassroomListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalClassrooms.value,
        }
    });

    const refetchData = function() {
        refClassroomListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, groupFilter], () => {
        refetchData()
    })

    const fetchClassrooms = function(ctx, callback) {
        store.dispatch('classrooms/fetchClassrooms', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            group: groupFilter.value,
        })
        .then(response => {
            const { classrooms, total } = response.data
            callback(classrooms)
            totalClassrooms.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching classrooms list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const fetchGroups = async function () { 
        groupOptions.value = (await getGroups()).data.groups;
        tableColumns.value = [
            { key: 'name', label: i18n.t('Name'), sortable: true },
            { key: groupOptions.value.length > 1 ? 'group' : '', label: i18n.t('Groups'), sortable: true },
            { key: 'actions', label: i18n.t('Actions') }
        ]

    }        
    fetchGroups()


    return {
        fetchClassrooms,
        tableColumns,
        perPage,
        currentPage,
        totalClassrooms,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refClassroomListTable,
        refetchData,
        groupFilter,
        groupOptions
    }
}
